import api from "./api";

// Get current user's subscription
export const getCurrentSubscription = async () => {
  const response = await api.get("/subscriptions/current");
  return response.data;
};

// Get current user's pending subscription requests
export const getPendingRequests = async () => {
  const response = await api.get("/subscriptions/pending");
  return response.data;
};

// Get all available subscription plans
export const getSubscriptionPlans = async () => {
  const response = await api.get("/subscriptions/plans");
  return response.data;
};

// Create a new subscription request
export const createSubscription = async (planId) => {
  const response = await api.post("/subscriptions/create", { planId });
  return response.data;
};

// Update/change subscription plan (creates a new pending request)
export const updateSubscription = async (planId) => {
  const response = await api.put("/subscriptions/update", { planId });
  return response.data;
};

// Cancel subscription
export const cancelSubscription = async () => {
  const response = await api.post("/subscriptions/cancel");
  return response.data;
};

// Get subscription usage
export const getSubscriptionUsage = async () => {
  const response = await api.get("/subscriptions/usage");
  return response.data;
};
